var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mt-2",attrs:{"variant":_vm.variant,"show":_vm.showAlert}},[_vm._v("\n    "+_vm._s(_vm._f("l")(_vm.message))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }